module.exports = __webpack_public_path__ + "static/media/CARRO.56be0a4e.png";